import { render, staticRenderFns } from "./frontPageTable.vue?vue&type=template&id=8994a0d8&scoped=true"
import script from "./frontPageTable.vue?vue&type=script&lang=js"
export * from "./frontPageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8994a0d8",
  null
  
)

export default component.exports